export const emptyValue = "–";
